module.exports = __webpack_public_path__ + "img/logo-dark.db003f60.svg";